import { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import moment from 'moment';
moment.locale('es');

const useExpandableRows = (config, catalogs, row) => {
    const [data, setData] = useState({});
    const [dataConfig, setDataConfig] = useState([]);
    
    useEffect(() => {
        setData({})
        setDataConfig([])
        let validateConfig = Array.isArray(config) ? config : [config]
        if(validateConfig.length > 0){
            let finalConfig = validateConfig.filter(item => item.channel === row.data.channel)[0]['accumulators']
            setDataConfig(finalConfig)
        }
        setData(row.data)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [row])

    const getValue = (catalog, key) => {
        let result = ''
        catalogs[catalog]?.map((g) => {
            if(g['k'] === String(key)){
                result = g['v'];
            }
            return result
        })
        return result
    }

    const getBooleanKey = (key) => {
        return key === 0 ? 'No' : 'Sí'
    }

    const verifyType = (name, prop) => {
        if(prop !== undefined){
            name = name.includes('date') ? 'date' : name
            switch(name){
                case 'source_general_gender':
                    return getValue('gender', prop);
                case 'source_general_nationality':
                    return getValue('country', prop);
                case 'source_general_occupation':
                    return getValue(data['accumulators']['is_corp'] === 0 ? 'occupations' : 'economicActivities', prop);
                case 'source_general_is_foreign':
                case 'is_common_domains':
                    return getBooleanKey(prop);
                case 'is_corp':
                    return getValue('customerOrigin', prop);
                case 'date':
                    return moment(prop).format('LLL')
                default:
                    return prop
            }
        } else {
            return 'N/A'
        }
    }

    return (
        <Box p={2} pl={8}>
            {data && data['accumulators'] && dataConfig.length > 0 && 
                <>
                    <Grid container pt={1} pb={1}><strong>Acumuladores</strong></Grid>
                    {dataConfig.map((item, key) => {
                        let prop = data['accumulators'][item.name]
                        return <Grid container spacing={2} key={key} pb={1}>
                            <Grid item xs={6}>{item.description}</Grid>
                            <Grid item xs={6}>{verifyType(item.name, prop)}</Grid>
                        </Grid>
                    })}
                </>
            }
            {data && dataConfig.length === 0 && data['accumulators'] && data['accumulators'].length > 0 && 
                <>
                    <Grid container pt={1} pb={1}><strong>Acumuladores</strong></Grid>
                    {data['accumulators']?.map((item, key) => {
                        return <Grid container spacing={2} key={key} pb={1}>
                            <Grid item xs={3}>{item.name}</Grid>
                            <Grid item xs={5}>{item.description}</Grid>
                            <Grid item xs={4}>{verifyType(item.name, item.value)}</Grid>
                        </Grid>
                    })}
                </>
            }
            {data && data['fields_expired'] && data['fields_expired'].length > 0 && 
                <>
                    <Grid container pt={1} pb={1}><strong>Campos de expiración</strong></Grid>
                    {data['fields_expired'].map((item, key) => {
                        return <Grid container spacing={2} key={key} pb={1}>
                            <Grid item xs={2}>{item.path}</Grid>
                            <Grid item xs={2}>Dato: {item.value}</Grid>
                            <Grid item xs={2}>Delta: {item.delta_expired}</Grid>
                            <Grid item xs={4}>{moment(item.expired_date).format('LLL')}</Grid>
                            <Grid item xs={2}>Evaluar: {item.evaluate ? 'Sí' : 'No'}</Grid>
                        </Grid>
                    })}
                </>
            }
            {data && data['reboots'] && data['reboots'].length > 0 && 
                <>
                    <Grid container pt={1} pb={1}><strong>Reboots</strong></Grid>
                    {data['reboots'].map((item, key) => {
                        return <Grid container spacing={2} key={key} pb={1}>
                            <Grid item xs={4}>{item.name}</Grid>
                            <Grid item xs={2}>Delta: {item.delta_expired}</Grid>
                            <Grid item xs={4}>{moment(item.expired_date).format('LLL')}</Grid>
                            <Grid item xs={2}>Evaluar: {item.evaluate ? 'Sí' : 'No'}</Grid>
                        </Grid>
                    })}
                </>
            }
        </Box>
    )
}

export default useExpandableRows;